/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Personas_System_Prompt_MaxInputs */



/**
* | output |
* | --- |
* | "System prompt must be at most {count} characters." |
*
* @param {Personas_System_Prompt_MaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_system_prompt_max = /** @type {((inputs: Personas_System_Prompt_MaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_System_Prompt_MaxInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`System-Prompt darf maximal ${i?.count} Zeichen lang sein.`)
	return /** @type {LocalizedString} */ (`System prompt must be at most ${i?.count} characters.`)
});